import PhoneInput, { PhoneNumber } from 'antd-phone-input';
import React from 'react';
import useForceRender from '../../hooks/context/useForceRender';
import { PhoneInputProps } from 'antd-phone-input/types';

export type Props = PhoneInputProps & {
  forwardKey: string;
  value: string;
  onChange: (value: string) => void;
};

export default function PhoneNumberInput({ forwardKey, value, onChange, ...rest }: Props) {
  const { findKey, forceRender } = useForceRender();

  const _onChange = (value: PhoneNumber) =>
    onChange(`+${value.countryCode ?? ''}${value.areaCode ?? ''}${value.phoneNumber ?? ''}`);

  const onPaste = (e: React.ClipboardEvent) => {
    const value = e.clipboardData.getData('Text');

    if (value.startsWith('+')) {
      onChange(value);
      forceRender(forwardKey);
    }
  };

  return (
    <PhoneInput
      {...rest}
      key={findKey(forwardKey)}
      value={value || ''}
      onChange={_onChange}
      onPaste={onPaste}
    />
  );
}
